import common from "./common.json";

export const es419 = {
  common,
};
